import PtIcon from '@patsnap-biz/icon';
import { CustomFieldLabelController, FIELD_MAIN_TYPE } from './CustomFieldLabelController';
import FieldContainer from './components/field/FieldContainer.vue';
import FieldFilterInput from './components/FieldFilterInput.vue';
import '@patsnap-ui/icon/assets/solid/ArrowRight.svg';
import '@patsnap-ui/icon/assets/solid/ArrowUp.svg';
import '@patsnap-ui/icon/assets/solid/NoDataTip.svg';
export default {
    name: 'CustomFieldLabelPane',
    components: {
        FieldContainer,
        FieldFilterInput,
        PtIcon,
    },
    provide() {
        return {
            controller: this.controller,
        };
    },
    props: {
        controller: {
            type: CustomFieldLabelController,
            required: true,
        },
    },
    data() {
        return {
            FIELD_MAIN_TYPE,
        };
    },
    watch: {
        'controller.fieldFilterString': function () {
            this.controller.expandAll();
        },
    },
};
